import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map, mergeMap } from "rxjs/operators";

import { AuthActions } from "../actions/auth.actions";
import { SpringAuthService } from "src/app/auth/spring-auth.service";
import { KeycloakAuthService } from "src/app/auth/keycloak-auth.service";
import { StringData } from "src/app/public/common/models/string-data.model";
//import { KeycloakAuthService } from "src/app/auth/keycloak-auth.service";



@Injectable()
export class AuthApiEffects{

    constructor(
        private springAuthService: SpringAuthService,
        private actions$: Actions
    ){}

    login$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(AuthActions.loginSubmit),
            concatMap( (action) => {
                return this.springAuthService
                    .login(action.loginCredentials)
                    .pipe( 
                        map( (result: StringData) => {
                            if(result.data.startsWith("ey"))
                                return AuthActions.authSuccess({ token: result.data });
                            else
                                return AuthActions.loginResult({ message: result.data });
                        } )
                        )
            })
        )
    });

    signup$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(AuthActions.signupSubmit),
            concatMap( (action) => {
                return this.springAuthService
                    .signup(action.signupCredentials)
                    .pipe( 
                        map( (result: StringData) => {
                            if(result.data.startsWith("ey"))
                                return AuthActions.authSuccess({ token: result.data });
                            else
                                return AuthActions.signupResult({ message: result.data });
                        } )
                        )
            })
        )
    });

    recoverPassword$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(AuthActions.recoverPasswordSubmit),
            concatMap( (action) => {
                return this.springAuthService
                    .recoverPassword(action.username)
                    .pipe( 
                        map( (result: StringData) => {
                            
                            return AuthActions.recoverPasswordResult({ message: result.data });
                        } )
                        )
            })
        )
    });

    updatePassword$ = createEffect( () => {
        return this.actions$.pipe(
            ofType(AuthActions.updatePasswordSubmit),
            concatMap( (action) => {
                return this.springAuthService
                    .updatePassword(action.oldPassword, action.newPassword)
                    .pipe( 
                        map( (result: StringData) => {
                            
                            return AuthActions.updatePasswordResult({ message: result.data });
                        } )
                        )
            })
        )
    });
}